export default '/build/748ec1a0.svg'